import React from 'react'
import Section from '../../landingPage/Section'
import ServiceCard from "../../../components/landingPage/IconCards/CircleIconOverlayCard";
import { Implantology, Endodontics, Orthodontics, Prosthodontics, Parodontology } from '../../../images/index';

  const services = [
    {
      title: "Orthodontics",
      description: "Invisible Aligners",
      id: 1,
      icon: Orthodontics
    },
    {
      title: "Parodontology",
      description: "Parodontitis<br/>Crown lengthening<br/>Flap surgery<br/>Gummy smile<br/>corrections",
      id: 2,
      icon: Parodontology
    },
    {
      title: "Endodontics",
      description: "Root canal treatments",
      id: 3,
      icon: Endodontics
    },
    { 
      title: "Implantology",
      description: "3D Planning & Placement<br/>Guided Surgery",
      id: 4,
      icon: Implantology
    },
    { 
      title: "Prosthodontics",
      description: "Inlays, onlays, overlays <br/> Veneers <br/> Crowns & Bridges <br/> Removable dentures",
      id: 5,
      icon: Prosthodontics
    },
  
  ];
  
  const subtitleStyle = {
    maxWidth:"1100px",
    margin: "auto auto"
  }

  function OurServices() {
    return (
      <Section
        title="Our Services"
        subtitleStyle={subtitleStyle}
        subtitle2Style={subtitleStyle}
        subtitle="XiViX offers a plethora of services & 3D imaging in the fields of orthodontics, paradontology, endociontics, implantology, and prosthodontics."
        subtitle2="Our partners and members follow the therapeutic gradient as a guideline for tratment plans: from minimally invasive treatments (like orthodontic aligners) to the complete replacement of a tooth (like implants), wherever necessary."
        id="Services"
        className="w-full"
      >
        <div className="flex flex-wrap lg:flex-row mx-auto lg:mx-18 gap-x-4 justify-center">
          {services.map((service) => {
            return (
              <div className="lg:mx-4">
                <ServiceCard service={service} key={service.id} />
              </div>
            );
          })}
        </div>
      </Section>
    );
  }

export default OurServices
